import { render, staticRenderFns } from "./AttributeCategoryItem.vue?vue&type=template&id=25968b30&scoped=true&"
import script from "./AttributeCategoryItem.vue?vue&type=script&lang=js&"
export * from "./AttributeCategoryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25968b30",
  null
  
)

export default component.exports